import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '@app/model/user';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient,private _router: Router, private permissionsService: NgxPermissionsService, private ngxRolesService: NgxRolesService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    //login(username: string, password: string, token: string) {
        login(username: string, password: string, token: string) {

        return this.http.post<any>(`${environment.apiUrl}/auth/generatetoken`, { username, password, token })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.accessToken) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }

                return user;
            }));
    }

    setPermissions() {
        let models = ['Job', 'Interview']
        let operations = ['Create', 'Update', 'Read', 'Delete'];
        let permissions = [];
        for (let model of models) {
            for (let operation of operations) {
                permissions.push(operation + model);
            }
        }

        this.permissionsService.addPermission(permissions);
        this.permissionsService.loadPermissions(permissions, (permissionName, permissionStore) => {
            return !!permissionStore[permissionName];
        })
        console.log(permissions, this.permissionsService);

        this.ngxRolesService.addRoles({
            'RECRUITER': ['CreateInterview'],
            'ADMIN': ['CreateInterview', 'CreateJob', 'DeleteJob'],
            'SUPER_ADMIN': ['CreateTechnology', 'CreateInterview', 'CreateJob', 'DeleteJob'],
            'DEVELOPER': () => { return true; }
        });
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        localStorage.removeItem('clearFilter');
        localStorage.removeItem('searchDto');
        this.currentUserSubject.next(null);
        this._router.navigate(['/login'])
    }
}